import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=12d2c873&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=12d2c873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2c873",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d2c873')) {
      api.createRecord('12d2c873', component.options)
    } else {
      api.reload('12d2c873', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=12d2c873&scoped=true&", function () {
      api.rerender('12d2c873', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sXgJmg14rNec/JS/teamMember.vue"
export default component.exports